module.exports = __webpack_public_path__ + "img/1540517219.b0688f94.jpg";